/** Duration to display the success message after survey submission (ms) */
export const SURVEY_SUCCESS_DISPLAY_DURATION_MS = 2000;

/** Cookie key for Genesys Cloud message ID */
export const COOKIE_KEY_MESSAGE_ID = 'cx_cloud_message_id';

/** Genesys default limit for customAttributes payload */
export const MAX_CUSTOM_ATTRIBUTES_SIZE_BYTES = 2048;

/** Max attempts when polling for widget client availability */
export const WIDGET_VISIBILITY_MAX_ATTEMPTS = 20;

/** Interval (ms) between widget client availability checks */
export const WIDGET_VISIBILITY_POLL_MS = 200;

/** Delay (ms) before showing the proactive chat trigger popup */
export const PROACTIVE_TRIGGER_DELAY_MS = 20_000;

/** sessionStorage key set when user dismisses the proactive chat popup */
export const PROACTIVE_CHAT_DISMISSED_KEY = 'online-proactive-chat-dismissed';

/** dataLayer event_name values indicating the user has already opened/started chat */
export const CHAT_OPENED_DATA_LAYER_EVENTS = ['chat_opened', 'chat_started'];

/**
 * Fallback agent display name sent by the genesys-frontend SDK's `SURVEY_OPEN`
 * event when a human agent joined the conversation but never had a Genesys
 * nickname configured (see `DEFAULT_HUMAN_AGENT_NAME` in chat-authors.ts on the
 * SDK side). We treat this generic, untranslated placeholder as "no name known".
 */
export const GENESYS_FALLBACK_AGENT_NAME = 'Live Agent';
